module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "setpwd-title"
  }, [_vm._v("微信支付配置")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "mt10",
    attrs: {
      "label-width": "150px",
      "model": _vm.wxpayData,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "支付商户号",
      "prop": "mchId"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "size": "normal"
    },
    model: {
      value: (_vm.wxpayData.mchId),
      callback: function($$v) {
        _vm.$set(_vm.wxpayData, "mchId", $$v)
      },
      expression: "wxpayData.mchId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "微信支付证书",
      "prop": "certFile"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": "#",
      "on-change": _vm.handleChange,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.fileList,
      "auto-upload": false
    },
    model: {
      value: (_vm.wxpayData.certFile),
      callback: function($$v) {
        _vm.$set(_vm.wxpayData, "certFile", $$v)
      },
      expression: "wxpayData.certFile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "width": "70%",
      "size": "mini",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("选取文件")])], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wxpayData.certFile),
      expression: "wxpayData.certFile"
    }]
  }, [_vm._v("已上传")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调用IP地址",
      "prop": "ip"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "textarea",
      "disabled": "disabled",
      "row": 3
    },
    model: {
      value: (_vm.wxpayData.ip),
      callback: function($$v) {
        _vm.$set(_vm.wxpayData, "ip", $$v)
      },
      expression: "wxpayData.ip"
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.wxpayData.ip),
      expression: "wxpayData.ip",
      arg: "copy"
    }],
    attrs: {
      "size": "small"
    }
  }, [_vm._v("复制")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "API密钥",
      "prop": "wechatKey"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "size": "small",
      "type": "text"
    },
    model: {
      value: (_vm.wxpayData.wechatKey),
      callback: function($$v) {
        _vm.$set(_vm.wxpayData, "wechatKey", $$v)
      },
      expression: "wxpayData.wechatKey"
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.wxpayData.wechatKey),
      expression: "wxpayData.wechatKey",
      arg: "copy"
    }],
    attrs: {
      "size": "small"
    }
  }, [_vm._v("复制")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "submit",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60d380a9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wechat/wechatPay.vue
// module id = 288
// module chunks = 48